import IconDots from './component.jsx'
export default IconDots
